export {default} from "./Typical";
